import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./Images/Logo.jpeg";

/* ═══════════════════════════════════════════════════════
   PIXEL-PERFECT BRAND SVG ICONS
═══════════════════════════════════════════════════════ */

const InstagramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const TwitterXIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const GoogleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

/* ── Utility Icons ── */
const CheckIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const ArrowRightIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
  </svg>
);

const MailIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const PhoneIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const MapPinIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const LockIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

const StarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="#FBBF24" aria-hidden="true">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const SpinnerIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <path strokeLinecap="round" d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);

/* ═══════════════════════════════════════════════════════
   DATA
═══════════════════════════════════════════════════════ */

const QUICK_LINKS = [
  { label: "Our Services", path: "/services" },
  { label: "Project Gallery", path: "/gallery" },
  { label: "Property Management", path: "/property-management" },
  { label: "Rental Agreements", path: "/rental-agreements" },
  { label: "Painting Services", path: "/painting-services" },
  { label: "Rental Furnitures", path: "/rental-furnitures" },
];

const SUPPORT_LINKS = [
  { label: "e-Khata Registration", path: "/e-khata" },
  { label: "BESCOM Transfer", path: "/bescom-transfer" },
  { label: "Buy Properties", path: "/buy" },
  { label: "Rent a Home", path: "/rent" },
  { label: "Lease Spaces", path: "/lease" },
  { label: "Contact Us", path: "/contact-us" },
];

const SOCIAL_LINKS = [
  {
    label: "Instagram",
    href: "https://instagram.com/housyhunt",
    icon: InstagramIcon,
    hoverBg: "#E1306C",
  },
  {
    label: "Facebook",
    href: "https://facebook.com/housyhunt",
    icon: FacebookIcon,
    hoverBg: "#1877F2",
  },
  {
    label: "X / Twitter",
    href: "https://twitter.com/housyhunt",
    icon: TwitterXIcon,
    hoverBg: "#000000",
  },
  {
    label: "LinkedIn",
    href: "https://linkedin.com/company/housyhunt",
    icon: LinkedInIcon,
    hoverBg: "#0A66C2",
  },
];

const TRUST_BADGES = [
  "RERA Compliant",
  "ISO 9001:2015 Certified",
  "SSL Secured",
  "RBI Approved Partners",
  "100% Verified Listings",
];

const STATS = [
  { value: "1.2L+", label: "Verified Listings" },
  { value: "40+",   label: "Active Cities"     },
  { value: "2.5L+", label: "Happy Buyers"      },
  { value: "850+",  label: "Expert Agents"     },
];

const AVATAR_COLORS = ["#F87171", "#60A5FA", "#FBBF24", "#34D399"];
const AVATAR_INITIALS = ["A", "D", "G", "J"];

const PERKS = ["Hot Deals Weekly", "Priority Property Access", "Expert Buying Guides"];

/* ═══════════════════════════════════════════════════════
   FOOTER COMPONENT
═══════════════════════════════════════════════════════ */
const Footer = () => {
  const [email, setEmail]           = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setEmail("");
      setShowSnackbar(true);
      setTimeout(() => setShowSnackbar(false), 4000);
    }, 900);
  };

  return (
    <>
      <footer className="w-full bg-[#0A0A0A] text-gray-300 overflow-hidden">

        {/* ────────────────────────────────────────────
            SECTION 1 — NEWSLETTER BANNER
        ──────────────────────────────────────────── */}
        <section className="relative overflow-hidden">

          {/* Layered red background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#C81E1E] via-[#991B1B] to-[#450A0A]" />

          {/* Subtle crosshatch texture */}
          <div
            className="absolute inset-0 opacity-[0.035]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`,
            }}
          />

          {/* Ambient glow orbs */}
          <div className="absolute -top-32 -left-20 w-[500px] h-[500px] rounded-full bg-white/[0.04] blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -right-12 w-[420px] h-[420px] rounded-full bg-black/30 blur-3xl pointer-events-none" />

          {/* Content */}
          <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-16">

            {/* ── LEFT COPY ── */}
            <div className="flex-1 max-w-lg">
              {/* Pill badge */}
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs font-bold text-white tracking-[0.15em] uppercase mb-7">
                <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                Premium Real Estate Newsletter
              </span>

              {/* Headline */}
              <h2 className="text-[2.6rem] md:text-5xl font-black text-white leading-[1.1] tracking-tight">
                Be the first to discover
                <br />
                <span className="text-red-200/90">your next dream property.</span>
              </h2>

              {/* Subtext */}
              <p className="mt-5 text-[15px] text-red-100/75 leading-relaxed">
                Exclusive listings, investment insights, neighbourhood trends, and
                early access to premium homes — delivered directly to your inbox.
              </p>

              {/* Perks */}
              <div className="flex flex-wrap gap-3 mt-8">
                {PERKS.map((perk) => (
                  <span
                    key={perk}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/15 text-sm text-white font-medium"
                  >
                    <CheckIcon className="w-3.5 h-3.5 text-green-400 shrink-0" />
                    {perk}
                  </span>
                ))}
              </div>

              {/* Social proof avatars + stars */}
              <div className="flex items-center gap-4 mt-10 pt-8 border-t border-white/10">
                <div className="flex -space-x-2.5">
                  {AVATAR_INITIALS.map((init, i) => (
                    <div
                      key={i}
                      style={{ backgroundColor: AVATAR_COLORS[i] }}
                      className="w-9 h-9 rounded-full border-2 border-[#991B1B] flex items-center justify-center text-xs font-black text-white shadow-md"
                    >
                      {init}
                    </div>
                  ))}
                </div>
                <div>
                  <div className="flex gap-0.5 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} className="w-3.5 h-3.5" />
                    ))}
                  </div>
                  <p className="text-xs text-red-100/60 font-medium">
                    Trusted by 2.5L+ home buyers
                  </p>
                </div>
              </div>
            </div>

            {/* ── RIGHT SUBSCRIBE CARD ── */}
            <div className="w-full lg:w-[460px] shrink-0">
              <div className="relative bg-white/[0.08] border border-white/[0.14] backdrop-blur-2xl rounded-3xl p-8 shadow-2xl shadow-black/40">

                {/* Decorative corner shimmer */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/[0.04] rounded-bl-full rounded-tr-3xl pointer-events-none" />

                {/* Card header */}
                <p className="text-[10px] font-black tracking-[0.22em] text-red-300/90 uppercase mb-1.5">
                  Subscribe & Stay Ahead
                </p>
                <h3 className="text-[1.6rem] font-black text-white leading-tight mb-1">
                  Get Exclusive Property Alerts
                </h3>
                <p className="text-sm text-red-100/55 mb-7 leading-relaxed">
                  Join thousands of investors staying ahead of the market.
                </p>

                {/* Form */}
                <form onSubmit={handleSubscribe} className="space-y-3" noValidate>
                  {/* Email input — NO absolute-positioned icon to avoid overflow */}
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="w-full px-5 py-4 rounded-2xl bg-white text-gray-900 placeholder-gray-400 text-sm font-medium focus:outline-none focus:ring-4 focus:ring-white/30 transition-all"
                  />

                  {/* Submit button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="group w-full bg-[#0F0F0F] hover:bg-[#1a1a1a] disabled:opacity-75 text-white font-bold py-4 rounded-2xl transition-all duration-300 flex items-center justify-center gap-3 text-sm shadow-xl hover:scale-[1.015] active:scale-[0.99]"
                  >
                    {isSubmitting ? (
                      <>
                        <SpinnerIcon className="w-4 h-4 animate-spin" />
                        Subscribing…
                      </>
                    ) : (
                      <>
                        Subscribe to Newsletter
                        <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
                      </>
                    )}
                  </button>
                </form>

                {/* Spam disclaimer */}
                <div className="flex items-center justify-center gap-2 mt-4">
                  <LockIcon className="w-3.5 h-3.5 text-green-400 shrink-0" />
                  <p className="text-[11px] text-red-100/45">
                    No spam. Unsubscribe anytime. Only premium property updates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ────────────────────────────────────────────
            SECTION DIVIDER
        ──────────────────────────────────────────── */}
        <div className="flex items-center max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
          <div className="mx-4 w-8 h-8 rounded-xl bg-[#1A1A1A] border border-white/10 flex items-center justify-center shrink-0">
            <svg className="w-4 h-4 text-[#E11D48]" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
          </div>
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        </div>

        {/* ────────────────────────────────────────────
            SECTION 2 — MAIN FOOTER GRID
        ──────────────────────────────────────────── */}
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-10">

          {/* ── COL 1 : BRAND (4 cols) ── */}
          <div className="lg:col-span-4 flex flex-col gap-6">

            {/* Logo image */}
            <div className="inline-flex">
              <img
                src={logo}
                alt="HousyHunt Logo"
                className="h-14 w-auto object-contain rounded-2xl"
              />
            </div>

            <p className="text-sm text-gray-400 leading-7">
              HousyHunt is India's trusted platform for discovering verified
              properties — from ready-to-move apartments to luxury villas and
              commercial spaces across 40+ cities.
            </p>

            {/* Contact rows */}
            <div className="space-y-3">
              {[
                { Icon: MailIcon,   text: "hello@housyhunt.com",     href: "mailto:hello@housyhunt.com" },
                { Icon: PhoneIcon,  text: "+91 97395 80142",          href: "tel:+919739580142"          },
                { Icon: MapPinIcon, text: "Bengaluru, Karnataka, India", href: null                       },
              ].map(({ Icon, text, href }) => (
                <div key={text} className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-[#161616] border border-white/[0.06] flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4 text-[#E11D48]" />
                  </div>
                  {href ? (
                    <a href={href} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                      {text}
                    </a>
                  ) : (
                    <span className="text-sm text-gray-400">{text}</span>
                  )}
                </div>
              ))}
            </div>

            {/* Social icons */}
            <div>
              <p className="text-[10px] font-black tracking-[0.2em] text-gray-600 uppercase mb-3">
                Follow Us
              </p>
              <div className="flex items-center gap-2">
                {SOCIAL_LINKS.map(({ label, href, icon: Icon, hoverBg }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    style={{ "--hover-bg": hoverBg }}
                    className="social-icon w-10 h-10 rounded-xl bg-[#161616] border border-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white transition-all duration-250 hover:-translate-y-0.5"
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = hoverBg; e.currentTarget.style.borderColor = "transparent"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ""; e.currentTarget.style.borderColor = ""; }}
                  >
                    <Icon className="w-[18px] h-[18px]" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* ── COL 2 : QUICK LINKS (2 cols) ── */}
          <div className="lg:col-span-2">
            <p className="text-[10px] font-black tracking-[0.2em] text-gray-600 uppercase mb-6">
              Quick Links
            </p>
            <ul className="space-y-4">
              {QUICK_LINKS.map(({ label, path }) => (
                <li key={label}>
                  <Link
                    to={path}
                    className="group inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    <span className="block w-0 group-hover:w-3 h-[1.5px] bg-[#E11D48] rounded-full transition-all duration-300 overflow-hidden" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── COL 3 : SUPPORT (2 cols) ── */}
          <div className="lg:col-span-2">
            <p className="text-[10px] font-black tracking-[0.2em] text-gray-600 uppercase mb-6">
              Customer Support
            </p>
            <ul className="space-y-4">
              {SUPPORT_LINKS.map(({ label, path }) => (
                <li key={label}>
                  <Link
                    to={path}
                    className="group inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    <span className="block w-0 group-hover:w-3 h-[1.5px] bg-[#E11D48] rounded-full transition-all duration-300 overflow-hidden" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── COL 4 : GET IN TOUCH (4 cols) ── */}
          <div className="lg:col-span-4">
            <p className="text-[10px] font-black tracking-[0.2em] text-gray-600 uppercase mb-5">
              Get in Touch
            </p>
            <p className="text-sm text-gray-400 leading-6 mb-6">
              Connect with our real estate experts for personalised assistance,
              site visits, and investment guidance.
            </p>

            {/* WhatsApp button */}
            <a
              href="https://wa.me/message/MDG2ZSZNG6P6G1"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3.5 w-full bg-[#111111] border border-white/[0.07] hover:border-[#25D366]/40 hover:bg-[#0a1a10] px-5 py-4 rounded-2xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#25D366]/10"
            >
              <span className="w-10 h-10 rounded-xl bg-[#25D366]/10 border border-[#25D366]/20 flex items-center justify-center shrink-0 group-hover:bg-[#25D366]/20 transition-colors duration-300">
                <WhatsAppIcon className="w-5 h-5 text-[#25D366]" />
              </span>
              <div className="text-left min-w-0">
                <p className="text-[13px] font-bold text-white">Chat on WhatsApp</p>
                <p className="text-xs text-gray-500 font-normal mt-0.5">Typically replies in minutes</p>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-gray-600 ml-auto shrink-0 group-hover:text-[#25D366] group-hover:translate-x-0.5 transition-all duration-200" />
            </a>

            {/* Google Reviews button */}
            <a
              href="https://g.page/r/housyhunt/review"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3.5 w-full bg-[#111111] border border-white/[0.07] hover:border-[#4285F4]/40 hover:bg-[#0a0e1a] px-5 py-4 rounded-2xl mt-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#4285F4]/10"
            >
              <span className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center shrink-0 group-hover:bg-white/10 transition-colors duration-300">
                <GoogleIcon className="w-5 h-5" />
              </span>
              <div className="text-left min-w-0">
                <p className="text-[13px] font-bold text-white">Rate us on Google</p>
                <div className="flex items-center gap-1 mt-0.5">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} className="w-3 h-3" />
                  ))}
                  <span className="text-[11px] text-gray-500 ml-1">4.9 · 340 reviews</span>
                </div>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-gray-600 ml-auto shrink-0 group-hover:text-[#4285F4] group-hover:translate-x-0.5 transition-all duration-200" />
            </a>

            {/* Stats mini-grid */}
            <div className="grid grid-cols-2 gap-2 mt-5">
              {STATS.map(({ value, label }) => (
                <div
                  key={label}
                  className="bg-[#111111] border border-white/[0.05] rounded-xl px-4 py-3"
                >
                  <p className="text-white font-black text-[1.25rem] leading-none">{value}</p>
                  <p className="text-gray-600 text-[10px] font-semibold mt-1 uppercase tracking-wide">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ────────────────────────────────────────────
            SECTION 3 — TRUST BADGE STRIP
        ──────────────────────────────────────────── */}
        <div className="border-t border-white/[0.05] bg-[#0D0D0D]">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {TRUST_BADGES.map((badge) => (
              <div key={badge} className="flex items-center gap-2 text-gray-600">
                <CheckIcon className="w-3 h-3 text-[#E11D48] shrink-0" />
                <span className="text-[11px] font-semibold tracking-wide">{badge}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ────────────────────────────────────────────
            SECTION 4 — BOTTOM COPYRIGHT BAR
        ──────────────────────────────────────────── */}
        <div className="border-t border-white/[0.04] bg-black">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-gray-600">
              © {new Date().getFullYear()} HousyHunt Technologies Pvt. Ltd. All rights reserved.
            </p>
            <nav className="flex items-center gap-5" aria-label="Legal links">
              {["Terms of Use", "Privacy Policy", "Cookie Policy", "Accessibility"].map((item) => (
                <a
                  key={item}
                  href="#"
                  className="text-xs text-gray-600 hover:text-gray-300 transition-colors duration-200"
                >
                  {item}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </footer>

      {/* ────────────────────────────────────────────
          SNACKBAR TOAST
      ──────────────────────────────────────────── */}
      <div
        role="status"
        aria-live="polite"
        className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
          showSnackbar
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-6 pointer-events-none"
        }`}
      >
        <div className="bg-[#111111] border border-white/10 rounded-2xl px-5 py-4 shadow-2xl flex items-center gap-3 min-w-[270px]">
          <span className="w-8 h-8 rounded-xl bg-green-500/10 border border-green-500/20 flex items-center justify-center shrink-0">
            <CheckIcon className="w-4 h-4 text-green-400" />
          </span>
          <div>
            <p className="text-sm font-bold text-white">You're subscribed!</p>
            <p className="text-xs text-gray-500 mt-0.5">Watch your inbox for exclusive listings.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;